/* Nidor — interactividad propia (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-mt-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-mt-parallax')) || 0;
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-r.top * k / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initComparador() {
    document.querySelectorAll('.mt-comparador').forEach(function (c) {
      var input = c.querySelector('input[type=range]');
      if (!input || c.dataset.mtInit) return;
      c.dataset.mtInit = '1';
      var set = function (v) { c.style.setProperty('--mt-pos', v + '%'); };
      input.addEventListener('input', function () { set(input.value); });
      set(input.value);
    });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-mt-cifra]');
    if (!nums.length) return;
    var run = function (el) {
      var fin = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
      var dec = (String(fin).split('.')[1] || '').length;
      if (reduce) { el.textContent = fin.toFixed(dec).replace('.', ','); return; }
      var t0 = null, dur = 1600;
      var step = function (t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec).replace('.', ',');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initSticky() {
    document.querySelectorAll('.mt-sticky').forEach(function (s) {
      var pasos = s.querySelectorAll('.mt-sticky__paso');
      var imgs = s.querySelectorAll('.mt-sticky__visual img');
      if (!pasos.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = parseInt(e.target.getAttribute('data-i'), 10);
          pasos.forEach(function (p, j) { p.classList.toggle('mt-activa', j === i); });
          imgs.forEach(function (im, j) { im.classList.toggle('mt-activa', j === i); });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  function initGaleria() {
    document.querySelectorAll('.mt-galeria').forEach(function (g) {
      var principal = g.querySelector('.mt-galeria__principal img');
      var minis = g.querySelectorAll('.mt-galeria__mini');
      if (!principal || g.dataset.mtInit) return;
      g.dataset.mtInit = '1';
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          minis.forEach(function (x) { x.classList.remove('mt-activa'); });
          m.classList.add('mt-activa');
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = m.getAttribute('data-src');
            principal.srcset = m.getAttribute('data-srcset') || '';
            principal.alt = m.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 150);
        });
      });
    });
  }

  function formatMoney(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var entero = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var coma = entero + ',' + parts[1];
    var punto = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (fmt || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, punto);
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      if (root.dataset.mtInit) return;
      root.dataset.mtInit = '1';
      var dataEl = root.querySelector('script[data-mt-variantes]');
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = root.getAttribute('data-money-format');
      var idInput = root.querySelector('input[name=id]');
      var selects = root.querySelectorAll('.mt-selector select');
      var precio = root.querySelector('[data-mt-precio]');
      var antes = root.querySelector('[data-mt-precio-antes]');
      var ahorro = root.querySelector('[data-mt-ahorro]');
      var boton = root.querySelector('[data-mt-boton]');
      var botonTxt = root.querySelector('[data-mt-boton-texto]');
      var estado = root.querySelector('[data-mt-estado]');
      var txtAgotado = root.getAttribute('data-txt-agotado');
      var txtBoton = root.getAttribute('data-txt-boton');
      var txtDisp = root.getAttribute('data-txt-disponible');
      var barraPrecio = document.querySelector('[data-mt-barra-precio]');

      function actualizar() {
        var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!v) {
          if (boton) boton.disabled = true;
          if (botonTxt) botonTxt.textContent = txtAgotado;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (precio) precio.textContent = formatMoney(v.price, fmt);
        if (barraPrecio) barraPrecio.textContent = formatMoney(v.price, fmt);
        var tieneAntes = v.compare_at_price && v.compare_at_price > v.price;
        if (antes) { antes.hidden = !tieneAntes; if (tieneAntes) antes.textContent = formatMoney(v.compare_at_price, fmt); }
        if (ahorro) { ahorro.hidden = !tieneAntes; if (tieneAntes) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        if (boton) boton.disabled = !v.available;
        if (botonTxt) botonTxt.textContent = v.available ? txtBoton : txtAgotado;
        if (estado) {
          estado.textContent = v.available ? txtDisp : txtAgotado;
          estado.classList.toggle('mt-compra__estado--agotado', !v.available);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      selects.forEach(function (s) { s.addEventListener('change', actualizar); });

      var qty = root.querySelector('.mt-cantidad input');
      root.querySelectorAll('.mt-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, n + parseInt(b.getAttribute('data-paso'), 10));
        });
      });

      var barra = document.querySelector('.mt-barra-fija');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          barra.classList.toggle('mt-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(boton);
      }
    });
  }

  function init() {
    initReveal(); initParallax(); initComparador(); initCifras(); initSticky(); initGaleria(); initProducto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
